export default __webpack_public_path__ + "static/media/userLW.747cdd63.svg";